import { DataSourceBase } from "@syla/shared/types/models/DataSourceBase";
import { WalletBase } from "@syla/shared/types/models/WalletBase";

export const getWalletName = ({
  wallet,
  dataSource,
}: {
  wallet: Pick<WalletBase<never>, "customName">;
  dataSource: Pick<DataSourceBase<string>, "name">;
}): string => wallet?.customName || dataSource.name;
